import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Observable } from 'rxjs/Observable';
import { AutosuggestService } from '../autosuggest.service';
import { INgxMyDpOptions, IMyDateModel } from 'ngx-mydatepicker';
import { environment } from '../../environments/environment';
import { EventEmitter } from "@angular/core";
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import * as XLSX from 'xlsx';
import { of } from 'rxjs/observable/of';

@Component({
  selector: 'app-customer-report',
  templateUrl: './customer-report.component.html',
  styleUrls: ['./customer-report.component.css']
})
export class CustomerReportComponent implements OnInit {
  dataSource;
  displayedColumns = ['sno', 'service_category', 'actions'];
  p: number = 1;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('mainChart') mainChart;

  columnNames = [{
    id: 'sno',
    value: 'S.No.',

  }, {
    id: 'service_category',
    value: 'Service Category',
  },
  {
    id: 'actions',
    value: 'Action',
  }
  ];



  @ViewChild('fileInput') fileInput;
  private appURL: string = environment.apiUrl;
  private uploadURL: string = environment.uploadUrl;
  public myFocusTriggeringEventEmitter = new EventEmitter<boolean>();
  myOptions: INgxMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    disableSince: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 }
    // This will disable dates starting from tomorrow
  };
  // Initialized to specific date (09.10.2018)
  model2: any = { date: { year: 2018, month: 10, day: 9 } };
  month1: any = {};
  wbetot_exp: any;
  mbetot_exp: any;
  model: any = {};
  user: any = {};
  results: any = {};
  currentUser: any = {};
  currentOrg: any;
  sessionData: any = {};
  searching = false;
  searchFailed = false;
  hideSearchingWhenUnsubscribed = new Observable(() => () => this.searching = false);
  certList: any = [];
  certificate: any = {};
  cert: any = {};
  contId: number;
  mask: any[] = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  tinmask: any[] = [/[0-9]/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  certmask: any[] = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  userType: number;
  showLoader: boolean;
  wbe_goal: number;
  mbe_goal: number;
  dataresult: any = [];
  recordsperpage: number = 25;
  datass: any = [];
  sortOrder = 0;

  visitsData: any[] = [];  // x-axis = dates
  visitsCount: any[] = []; // y-axis = visit counts
  chartOption: any;  // <-- Add this line
  pieData: any[] = [];  // x-axis = dates
  pieOption: any;  // x-axis = dates
  chartName: string;
  stock_area_do: any = [];


  constructor(
    private router: Router,
    private loginservice: LoginService,
    private Autosuggest: AutosuggestService,
    private _flashMessagesService: FlashMessagesService

  ) {
  }

  covenants: any = [
    { provinceID: 1 },
    { provinceID: 2 },
    { provinceID: 3 },
    { provinceID: 4 },
    { provinceID: 5 },
  ];

  openCoverages = false;
  indexSelectedCoverage = 1;

  ngOnInit(): void {
    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
    this.getAllstock_area();
    this.chartOption = {}; // or your default chart config
    this.pieOption = {};   // default config
    this.model['start_date'] = '';
    this.model['end_date'] = '';
    this.model['bill_no'] = '';
    this.model['f_name'] = '';
    this.model['phone'] = '';
    this.model['serviced_area'] = '';
    this.model['line'] = false;
    this.model['bar'] = false;
    this.model['pie'] = false;
    this.model['totalVisit'] = false;
    this.model['newVisit'] = false;
    this.model['totalService'] = false;
    this.model['totalCustomers'] = false;
    this.model['howKnow'] = false;
    this.model['billRatio'] = false;
    this.model['consolidate'] = false;
    // this.displayedColumns = this.columnNames.map(x => x.id);

    this.covenants.forEach((_covenants) => {
      _covenants.isExpanded = false;
    });
    const now = new Date();
    // Start date: 1st of current month
    const startDate = new Date(now.getFullYear(), now.getMonth(), 1);
    // End date: today
    const endDate = now;

    // this.model.start_date = this.formatDateForPicker(startDate);
    // this.model.end_date = this.formatDateForPicker(endDate);
    this.getCustomerList('');
  }

  formatDateForPicker(dateObj: Date) {
    const year = dateObj.getFullYear();
    const month = dateObj.getMonth() + 1;
    const day = dateObj.getDate();

    return {
      date: { year: year, month: month, day: day },
      jsdate: dateObj.toISOString(),
      formatted: this.formatDDMMYYYY(day, month, year),
      epoc: Math.floor(dateObj.getTime() / 1000)
    };
  }

  formatDDMMYYYY(day: number, month: number, year: number): string {
    return this.pad(day) + '/' + this.pad(month) + '/' + year;
  }

  pad(n: number): string {
    return n < 10 ? '0' + n : n.toString();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.getChart();
      this.piechart();
    }, 500);
  }

  onDateChanged(type, event: IMyDateModel): void {
  }

  chartType(event, chartType, reportType) {
    if (event.target.checked === true && chartType === 'Line') {
      this.chartName = chartType;
      this.model['pie'] = false;
      this.model['bar'] = false;
    }

    if (event.target.checked === true && chartType === 'Bar') {
      this.chartName = chartType;
      this.model['line'] = false;
      this.model['pie'] = false;
    }

    if (event.target.checked === true && chartType === 'Pie') {
      this.chartName = chartType;
      this.model['line'] = false;
      this.model['bar'] = false;
    }

    if (event.target.checked === true && chartType === 'totalVisit') {
      this.model['totalService'] = false;
      this.model['newVisit'] = false;
      this.model['totalCustomers'] = false;
      this.model['howKnow'] = false;
      this.model['billRatio'] = false;
    }

    if (event.target.checked === true && chartType === 'newVisit') {
      this.model['totalVisit'] = false;
      this.model['totalService'] = false;
      this.model['totalCustomers'] = false;
      this.model['howKnow'] = false;
      this.model['billRatio'] = false;
    }

    if (event.target.checked === true && chartType === 'totalService') {
      this.model['totalVisit'] = false;
      this.model['newVisit'] = false;
      this.model['totalCustomers'] = false;
      this.model['howKnow'] = false;
      this.model['billRatio'] = false;
    }

    if (event.target.checked === true && chartType === 'totalCustomers') {
      this.model['totalVisit'] = false;
      this.model['newVisit'] = false;
      this.model['totalService'] = false;
      this.model['howKnow'] = false;
      this.model['billRatio'] = false;
    }

    if (event.target.checked === true && chartType === 'howKnow') {
      this.model['totalVisit'] = false;
      this.model['newVisit'] = false;
      this.model['totalService'] = false;
      this.model['totalCustomers'] = false;
      this.model['billRatio'] = false;
    }

    if (event.target.checked === true && chartType === 'billRatio') {
      this.model['totalVisit'] = false;
      this.model['newVisit'] = false;
      this.model['totalService'] = false;
      this.model['totalCustomers'] = false;
      this.model['howKnow'] = false;
    }

    if (event.target.checked === true) {
      setTimeout(() => this.generateDynamicChart(), 300);
    } else if (event.target.checked === false && chartType === 'consolidate') {
      setTimeout(() => this.generateDynamicChart(), 300);
    }
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  addvendor() {
    this.router.navigate(['add-Serviceoffered']);
  }

  getCustomerList(data) {
    this.model['line'] = false;
    this.model['bar'] = false;
    this.model['pie'] = false;
    this.model['totalVisit'] = false;
    this.model['newVisit'] = false;
    this.model['totalService'] = false;
    this.model['totalCustomers'] = false;
    this.model['howKnow'] = false;
    this.model['billRatio'] = false;
    this.showLoader = true;
    // if (data.start_date) {

    // } else {
    //   data = {
    //     start_date: this.model['start_date'],
    //     end_date: this.model['end_date'],
    //     bill_no: this.model['bill_no'],
    //     f_name: this.model['f_name'],
    //     phone: this.model['phone'],
    //   };
    // }

    this.loginservice.getCustomerList(data, this.currentUser)
      .subscribe(
        data => {
          if (data['comp_details'].length > 0) {
            this.dataresult = data['comp_details'];
            this.certList.contractorId = this.model['Id'];
            this.certList.uid = this.currentUser['uid'];
            this.certificate = data;
            this.showLoader = false;
            let tableArr: Element[] = data['comp_details'];
            this.dataSource = new MatTableDataSource(tableArr);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
            // setTimeout(() => {
            //   this.getChart();
            //   this.piechart();
            // }, 300); // waits for data + DOM to update
          } else {
            this.dataresult.length = 0;
            // this._flashMessagesService.show('No Subcontractors!', { cssClass: 'alert-danger' });
            // this.router.navigate(['addlowertier']);
            this.showLoader = false;
            let tableArr: Element[] = [];
            this.dataSource = new MatTableDataSource(tableArr);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
            this.model['line'] = false;
            this.model['bar'] = false;
            this.model['pie'] = false;
            this.model['totalVisit'] = false;
            this.model['newVisit'] = false;
            this.model['totalService'] = false;
            this.model['totalCustomers'] = false;
            this.model['howKnow'] = false;
            this.model['billRatio'] = false;
          }
        },
        error => {
          alert('Network Error getCustomerList API');
          this.showLoader = false;
          this.model['line'] = false;
          this.model['bar'] = false;
          this.model['pie'] = false;
          this.model['totalVisit'] = false;
          this.model['newVisit'] = false;
          this.model['totalService'] = false;
          this.model['totalCustomers'] = false;
          this.model['howKnow'] = false;
          this.model['billRatio'] = false;
        });

  }


  // Angular component code
  handleClick(columnId: string, element: any) {
    switch (columnId) {
      // case 'edit':
      //   this.edit(element.vendor_id);
      //   break;
      // case 'view':
      //   this.view(element.vendor_id);
      //   break;
      case 'delete':
        this.delete(element.vendor_id);
        break;
      default:
        break;
    }
  }

  delete(service_category_id: number) {
    // Handle delete action
    // alert('delete');
    // alert(service_category_id);
    if (confirm('Deleting of this Service Offered is done from the entire system')) {
      if (confirm('Are you sure want to delete')) {
        this.loginservice.deletegridDataNew(service_category_id, 'service_category_id', 'service_offered', 'status', '1').subscribe(data => {
          this._flashMessagesService.show('Deleted Successfully', { cssClass: 'alert-success' });
          this.ngOnInit();
        },
          error => {
            alert('Network Error delete API');
            this.showLoader = false;
          });
      }
    }
  }

  search() {
    if (this.model['bill_no'] == '' && this.model['f_name'] == '' && this.model['phone'] == '' && this.model['serviced_area'] == '') {
      if (this.model['start_date'] == '' || this.model['end_date'] == '') {
        alert('Please Select Start & End Date & Bill No.');
        this._flashMessagesService.show('Please Select Start & End Date & Bill No.', { cssClass: 'alert-danger' });
        return true;
      }
    } else {
      if (this.model['start_date'] != '' && this.model['end_date'] == '') {
        alert('Please Select End Date');
        this._flashMessagesService.show('Please Select End Date', { cssClass: 'alert-danger' });
        return true;
      } else if (this.model['start_date'] == '' && this.model['end_date'] != '') {
        alert('Please Select Start Date');
        this._flashMessagesService.show('Please Select Start Date', { cssClass: 'alert-danger' });
        return true;
      }
    }
    let data = {
      start_date: this.model['start_date'],
      end_date: this.model['end_date'],
      bill_no: this.model['bill_no'],
      f_name: this.model['f_name'],
      phone: this.model['phone'],
      serviced_area: this.model['serviced_area'],
    };
    this.getCustomerList(data)
  }

  reset() {
    this.model['start_date'] = '';
    this.model['end_date'] = '';
    this.model['bill_no'] = '';
    this.ngOnInit();
  }

  changeRecordPerPage(value) {
    this.recordsperpage = value;
  }

  tableToExcel(table, excelName) {

    let list: any = [];
    var exports1 = [];
    this.datass = this.dataresult;
    exports1 = this.dataresult;
    let sno = 0;
    exports1.forEach(element => {
      sno = sno + 1;
      list.push({ '#': sno, 'Customer Name': element.f_name, 'Phone': element.phone, 'Total Visit': element.total_visit, 'Total Service': element.total_service });
    });


    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(list);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    XLSX.writeFile(workbook, excelName + '.xls', { bookType: 'xls', type: 'buffer' });
  }

  sortable(sort) {
    let order = ""
    if (this.sortOrder == 0) {
      order = "DESC";
      this.sortOrder = 1;
    } else {
      order = "ASC";
      this.sortOrder = 0;
    }
    let data = {
      start_date: this.model['start_date'],
      end_date: this.model['end_date'],
      bill_no: this.model['bill_no'],
      f_name: this.model['f_name'],
      phone: this.model['phone'],
      sort: sort,
      sortOrder: order
    };
    this.getCustomerList(data)
  }

  piechart() {

    const categoryMap = {};

    this.dataresult.forEach(c => {
      if (c.billing) {
        c.billing.forEach(b => {
          const cat = b.service_category;
          if (!categoryMap[cat]) categoryMap[cat] = 0;
          categoryMap[cat] += 1;
        });
      }
    });

    this.pieData = Object.keys(categoryMap).map(k => ({
      name: k,
      value: categoryMap[k]
    }));

    this.pieOption = {
      title: {
        text: 'Service Category Breakdown',
        left: 'center'
      },
      tooltip: { trigger: 'item' },
      series: [
        {
          name: 'Services',
          type: 'pie',
          radius: '60%',
          data: this.pieData,
          label: {
            formatter: '{b}: {c}'
          }
        }
      ]
    };
  }

  generateDynamicChart() {
    const reportType = this.model.totalVisit ? 'totalVisit' :
      this.model.newVisit ? 'newVisit' :
        this.model.totalService ? 'totalService' :
          this.model.totalCustomers ? 'totalCustomers' :
            this.model.howKnow ? 'howKnow' :
              this.model.billRatio ? 'billRatio' : null;

    const chartType = this.model.line ? 'line' :
      this.model.bar ? 'bar' :
        this.model.pie ? 'pie' : null;

    if (!reportType || !chartType) {
      this.chartOption = {};
      return;
    }

    const dataMap = {};
    const raw = this.dataresult;
    const isConsolidate = this.model.consolidate;

    if (reportType === 'totalVisit') {
      if (isConsolidate) {
        const totalSet = new Set();
        raw.forEach(c => {
          if (c.billing) {
            c.billing.forEach(b => totalSet.add(b.bill_no));
          }
        });
        this.visitsData = ['Total'];
        this.visitsCount = [totalSet.size];
      } else {
        raw.forEach(c => {
          if (c.billing) {
            c.billing.forEach(b => {
              if (!dataMap[b.date]) dataMap[b.date] = new Set();
              dataMap[b.date].add(b.bill_no);
            });
          }
        });
        const sortedDates = Object.keys(dataMap).sort();
        this.visitsData = sortedDates.map(d => this.formatDate(d));
        this.visitsCount = sortedDates.map(d => dataMap[d].size);
      }
    } else if (reportType === 'totalCustomers') {
      if (isConsolidate) {
        const totalSet = new Set();
        raw.forEach(c => {
          if (c.billing) {
            c.billing.forEach(b => totalSet.add(b.customer_id));
          }
        });
        this.visitsData = ['Total'];
        this.visitsCount = [totalSet.size];
      } else {
        raw.forEach(c => {
          if (c.billing) {
            c.billing.forEach(b => {
              if (!dataMap[b.date]) dataMap[b.date] = new Set();
              dataMap[b.date].add(b.customer_id);
            });
          }
        });
        const sortedDates = Object.keys(dataMap).sort();
        this.visitsData = sortedDates.map(d => this.formatDate(d));
        this.visitsCount = sortedDates.map(d => dataMap[d].size);
      }
    } else if (reportType === 'newVisit') {
      if (isConsolidate) {
        let total = 0;
        raw.forEach(c => {
          if (c.total_visit === 1) total++;
        });
        this.visitsData = ['Total'];
        this.visitsCount = [total];
      } else {
        raw.forEach(c => {
          if (c.total_visit === 1 && c.billing && c.billing.length > 0) {
            const date = c.billing[0].date;
            if (!dataMap[date]) dataMap[date] = 0;
            dataMap[date]++;
          }
        });
        const sortedDates = Object.keys(dataMap).sort();
        this.visitsData = sortedDates.map(d => this.formatDate(d));
        this.visitsCount = sortedDates.map(d => dataMap[d]);
      }
    } else if (reportType === 'totalService') {
      if (isConsolidate) {
        let total = 0;
        raw.forEach(c => {
          if (c.billing) total += c.billing.length;
        });
        this.visitsData = ['Total'];
        this.visitsCount = [total];
      } else {
        raw.forEach(c => {
          if (c.billing) {
            c.billing.forEach(b => {
              if (!dataMap[b.date]) dataMap[b.date] = 0;
              dataMap[b.date]++;
            });
          }
        });
        const sortedDates = Object.keys(dataMap).sort();
        this.visitsData = sortedDates.map(d => this.formatDate(d));
        this.visitsCount = sortedDates.map(d => dataMap[d]);
      }
    } else if (reportType === 'howKnow') {
      if (isConsolidate) {
        const howMap = {};
        raw.forEach(c => {
          if (c.how) {
            if (!howMap[c.how]) howMap[c.how] = 0;
            howMap[c.how]++;
          }
        });
        this.visitsData = Object.keys(howMap);
        this.visitsCount = Object.values(howMap);
      } else {
        const dateHowMap = {};
        const howSources = new Set();
        const processedCustomers = new Set();
        raw.forEach(c => {
          if (c.billing && c.how) {
            c.billing.forEach(b => {
              const date = b.date;
              const key = `${date}-${c.id}`;
              if (!processedCustomers.has(key)) {
                if (!dateHowMap[date]) dateHowMap[date] = {};
                if (!dateHowMap[date][c.how]) dateHowMap[date][c.how] = 0;
                dateHowMap[date][c.how]++;
                howSources.add(c.how);
                processedCustomers.add(key);
              }
            });
          }
        });
        const dates = Object.keys(dateHowMap).sort();
        this.visitsData = dates.map(d => this.formatDate(d));
        const seriesData = [];
        howSources.forEach(how => {
          const data = dates.map(date => dateHowMap[date][how] || 0);
          seriesData.push({ name: how, data: data });
        });
        this.visitsCount = seriesData;
      }
    } else if (reportType === 'billRatio') {
      if (isConsolidate) {
        const customerBillMap = {};
        raw.forEach(c => {
          if (c.totBill && c.f_name) {
            customerBillMap[c.f_name] = parseFloat(c.totBill) || 0;
          }
        });
        this.visitsData = Object.keys(customerBillMap);
        this.visitsCount = Object.values(customerBillMap);
      } else {
        const dateCustomerMap = {};
        const customers = new Set();
        const processedBills = new Set();
        raw.forEach(c => {
          if (c.billing && c.f_name) {
            c.billing.forEach(b => {
              const date = b.date;
              const billKey = `${date}-${b.bill_no}`;
              if (!processedBills.has(billKey)) {
                if (!dateCustomerMap[date]) dateCustomerMap[date] = {};
                if (!dateCustomerMap[date][c.f_name]) dateCustomerMap[date][c.f_name] = 0;
                dateCustomerMap[date][c.f_name] += parseFloat(b.invoiceTotal) || 0;
                customers.add(c.f_name);
                processedBills.add(billKey);
              }
            });
          }
        });
        const dates = Object.keys(dateCustomerMap).sort();
        this.visitsData = dates.map(d => this.formatDate(d));
        const seriesData = [];
        customers.forEach(customer => {
          const data = dates.map(date => dateCustomerMap[date][customer] || 0);
          seriesData.push({ name: customer, data: data });
        });
        this.visitsCount = seriesData;
      }
    }

    const title = reportType.replace(/([A-Z])/g, ' $1').trim().replace(/^\w/, c => c.toUpperCase());

    if ((reportType === 'howKnow' || reportType === 'billRatio') && chartType === 'pie') {
      // Pie chart for howKnow - total count per source
      const totalBySource = {};
      if (isConsolidate) {
        this.visitsData.forEach((name, i) => {
          totalBySource[name] = this.visitsCount[i];
        });
      } else {
        this.visitsCount.forEach(s => {
          totalBySource[s.name] = s.data.reduce((a, b) => a + b, 0);
        });
      }
      this.chartOption = {
        backgroundColor: '#fff',
        title: { text: title, left: 'center', top: 20, textStyle: { fontSize: 20, fontWeight: 'bold', color: '#333' } },
        tooltip: { trigger: 'item', formatter: '{b}: {c} ({d}%)', backgroundColor: 'rgba(50,50,50,0.9)', textStyle: { color: '#fff' } },
        legend: { orient: 'vertical', left: 'left', top: 'middle', textStyle: { fontSize: 12 } },
        color: ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'],
        series: [{
          type: 'pie',
          radius: ['40%', '70%'],
          center: ['60%', '50%'],
          itemStyle: { borderRadius: 10, borderColor: '#fff', borderWidth: 2 },
          label: { show: true, formatter: '{b}: {c}', fontSize: 12 },
          emphasis: { label: { show: true, fontSize: 14, fontWeight: 'bold' }, itemStyle: { shadowBlur: 10, shadowColor: 'rgba(0, 0, 0, 0.5)' } },
          data: Object.keys(totalBySource).map(k => ({ name: k, value: totalBySource[k] }))
        }]
      };
    } else if ((reportType === 'howKnow' || reportType === 'billRatio') && isConsolidate) {
      // Consolidated howKnow - bar/line chart
      this.chartOption = {
        backgroundColor: '#fff',
        title: { text: title, left: 'center', top: 20, textStyle: { fontSize: 20, fontWeight: 'bold', color: '#333' } },
        tooltip: { trigger: 'axis', backgroundColor: 'rgba(50,50,50,0.9)', textStyle: { color: '#fff' } },
        dataZoom: [
          { type: 'slider', show: true, xAxisIndex: 0, start: 0, end: 100 }
        ],
        grid: { left: 60, right: 40, top: 80, bottom: 100, containLabel: true },
        xAxis: { type: 'category', data: this.visitsData, axisLabel: { rotate: 45, fontSize: 11, color: '#666' }, axisLine: { lineStyle: { color: '#ddd' } } },
        yAxis: { type: 'value', axisLabel: { fontSize: 11, color: '#666' }, axisLine: { lineStyle: { color: '#ddd' } }, splitLine: { lineStyle: { color: '#f0f0f0' } } },
        series: [{
          type: chartType,
          data: this.visitsCount,
          itemStyle: { borderRadius: chartType === 'bar' ? [8, 8, 0, 0] : 0 },
          label: { show: true, position: 'top', fontSize: 11, fontWeight: 'bold' },
          emphasis: { itemStyle: { shadowBlur: 10, shadowColor: 'rgba(0,0,0,0.3)' } }
        }]
      };
    } else if (reportType === 'howKnow' || reportType === 'billRatio') {
      // Line/Bar chart for howKnow/billRatio - date-wise with multiple series
      this.chartOption = {
        backgroundColor: '#fff',
        title: { text: title, left: 'center', top: 20, textStyle: { fontSize: 20, fontWeight: 'bold', color: '#333' } },
        tooltip: { trigger: 'axis', backgroundColor: 'rgba(50,50,50,0.9)', textStyle: { color: '#fff' } },
        legend: {
          data: this.visitsCount.map(s => s.name),
          top: 60,
          type: 'scroll',
          textStyle: { fontSize: 12 }
        },
        dataZoom: [
          { type: 'slider', show: true, xAxisIndex: 0, start: 0, end: 100 }
        ],
        grid: { left: 60, right: 40, top: 100, bottom: 100, containLabel: true },
        xAxis: { type: 'category', data: this.visitsData, axisLabel: { rotate: 45, fontSize: 11, color: '#666' }, axisLine: { lineStyle: { color: '#ddd' } } },
        yAxis: { type: 'value', axisLabel: { fontSize: 11, color: '#666' }, axisLine: { lineStyle: { color: '#ddd' } }, splitLine: { lineStyle: { color: '#f0f0f0' } } },
        series: this.visitsCount.map(s => ({
          name: s.name,
          type: chartType,
          data: s.data,
          smooth: chartType === 'line',
          stack: chartType === 'bar' ? 'total' : undefined,
          itemStyle: { borderRadius: chartType === 'bar' ? [8, 8, 0, 0] : 0 },
          lineStyle: chartType === 'line' ? { width: 2 } : undefined,
          label: { show: false },
          emphasis: { itemStyle: { shadowBlur: 10, shadowColor: 'rgba(0,0,0,0.3)' } }
        }))
      };
    } else if (chartType === 'pie') {
      this.chartOption = {
        backgroundColor: '#fff',
        title: {
          text: title,
          left: 'center',
          top: 20,
          textStyle: { fontSize: 20, fontWeight: 'bold', color: '#333' }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c} ({d}%)',
          backgroundColor: 'rgba(50,50,50,0.9)',
          textStyle: { color: '#fff' }
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          top: 'middle',
          textStyle: { fontSize: 12 }
        },
        color: ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'],
        series: [{
          type: 'pie',
          radius: ['40%', '70%'],
          center: ['60%', '50%'],
          avoidLabelOverlap: true,
          itemStyle: {
            borderRadius: 10,
            borderColor: '#fff',
            borderWidth: 2
          },
          label: {
            show: true,
            formatter: '{b}: {c}',
            fontSize: 12
          },
          emphasis: {
            label: { show: true, fontSize: 14, fontWeight: 'bold' },
            itemStyle: { shadowBlur: 10, shadowOffsetX: 0, shadowColor: 'rgba(0, 0, 0, 0.5)' }
          },
          data: this.visitsData.map((d, i) => ({ name: d, value: this.visitsCount[i] }))
        }]
      };
    } else {
      this.chartOption = {
        backgroundColor: '#fff',
        title: {
          text: title,
          left: 'center',
          top: 20,
          textStyle: { fontSize: 20, fontWeight: 'bold', color: '#333' }
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(50,50,50,0.9)',
          textStyle: { color: '#fff' },
          axisPointer: { type: 'shadow', shadowStyle: { color: 'rgba(150,150,150,0.1)' } }
        },
        grid: { left: 60, right: 40, top: 80, bottom: 60, containLabel: true },
        xAxis: {
          type: 'category',
          data: this.visitsData,
          axisLabel: { rotate: 45, fontSize: 11, color: '#666' },
          axisLine: { lineStyle: { color: '#ddd' } }
        },
        yAxis: {
          type: 'value',
          axisLabel: { fontSize: 11, color: '#666' },
          axisLine: { lineStyle: { color: '#ddd' } },
          splitLine: { lineStyle: { color: '#f0f0f0' } }
        },
        series: [{
          type: chartType,
          data: this.visitsCount,
          smooth: chartType === 'line',
          itemStyle: {
            color: chartType === 'line' ? '#5470c6' : {
              type: 'linear',
              x: 0, y: 0, x2: 0, y2: 1,
              colorStops: [
                { offset: 0, color: '#5470c6' },
                { offset: 1, color: '#91cc75' }
              ]
            },
            borderRadius: chartType === 'bar' ? [8, 8, 0, 0] : 0
          },
          lineStyle: chartType === 'line' ? { width: 3 } : undefined,
          areaStyle: chartType === 'line' ? {
            color: {
              type: 'linear',
              x: 0, y: 0, x2: 0, y2: 1,
              colorStops: [
                { offset: 0, color: 'rgba(84,112,198,0.3)' },
                { offset: 1, color: 'rgba(84,112,198,0.05)' }
              ]
            }
          } : undefined,
          label: { show: true, position: 'top', fontSize: 11, fontWeight: 'bold' },
          emphasis: { itemStyle: { shadowBlur: 10, shadowColor: 'rgba(0,0,0,0.3)' } }
        }]
      };
    }
  }

  formatDate(dateStr: string): string {
    if (!dateStr) return dateStr;
    const parts = dateStr.split('-');
    if (parts.length === 3) {
      return `${parts[2]}-${parts[1]}-${parts[0]}`;
    }
    return dateStr;
  }

  getBillRowspan(billing: any[], index: number): number {
    if (index > 0 && billing[index - 1].bill_no === billing[index].bill_no) return 0;
    let count = 1;
    for (let i = index + 1; i < billing.length; i++) {
      if (billing[i].bill_no === billing[index].bill_no) count++;
      else break;
    }
    return count;
  }

  getChart() {
    this.generateDynamicChart();
  }

  getAllstock_area() {
    this.loginservice.getAllstock_area(this.currentUser).subscribe(
      data => {
        if (data['status'] == 'success' && data['data'].length > 0) {
          this.stock_area_do = data['data'];
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/customer-report/customer-report.component.ts